import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IUserCardData, IUserCardAction } from 'models/user/usercard';
import { IStore } from 'redux/IStore';
import { IItemCardList } from 'models/itemcard';
import { IUserPreferences } from 'models/user/userpreferences';
import { ItemCardList } from 'components';
import {
	getUserFollowing,
	followUser,
	unfollowItem,
	resetUserFollowingData,
	setKeywordFilter,
	getUserCard,
} from 'modules/user/usercard';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { IShopCardAction } from 'models/shop/shopcard';
import { goToCard } from '../../../helpers/common';
import SearchUsers from 'containers/Search/SearchUsers';
const { connect } = require('react-redux');

interface IProps {
	userCardData?: IUserCardData;
	userPreferences?: IUserPreferences;
	dispatch?: any;

	/* function props */
	t?: (key: string, options?: any) => string;
	followUser?: (id: string, isUserCardFollowButton: boolean) => IUserCardAction;
	unfollowItem?: (
		id: string,
		type: string,
		isUserCardFollowButton: boolean,
		isFollowingTab: boolean,
	) => IUserCardAction;
	getUserFollowing?: (userId: string, isFirstLoad: boolean, keyword: string) => IUserCardAction;
	resetUserFollowingData?: () => IUserCardAction;
	setKeywordFilter?: (keywordFilter: string) => IUserCardAction;
	getUserCard?: (id: string) => IUserCardAction;
	getShopCard?: (id: string) => IShopCardAction;
}

interface IState {
	hasFollowers: boolean;
}

interface IUserFollowingCardList extends IItemCardList {
	followItem?: (itemType: string, itemId: string) => void;
	unfollowItem?: (itemType: string, itemId: string) => void;
}

@connect(
	(state: IStore) => ({
		userCardData: state.usercard,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getUserFollowing: (id: string, isFirstLoad: boolean, keyword: string) =>
			dispatch(getUserFollowing(id, isFirstLoad, keyword)),
		followUser: (id: string, isUserCardFollowButton: boolean) => dispatch(followUser(id, isUserCardFollowButton)),
		unfollowItem: (id: string, type: string, isUserCardFollowButton: boolean, isFollowingTab: boolean) =>
			dispatch(unfollowItem(id, type, isUserCardFollowButton, isFollowingTab)),
		resetUserFollowingData: () => dispatch(resetUserFollowingData()),
		setKeywordFilter: (keywordFilter: string) => dispatch(setKeywordFilter(keywordFilter)),
		getUserCard: (id: string) => dispatch(getUserCard(id)),
		getShopCard: (id: string) => dispatch(getShopCard(id)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserFollowing extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			hasFollowers: false,
		};

		this.loadMoreUserFollowing = this.loadMoreUserFollowing.bind(this);
		this.followUser = this.followUser.bind(this);
		this.unfollowItem = this.unfollowItem.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}
	customRef = React.createRef<HTMLInputElement>();

	public componentDidMount() {
		// Set hasFollowers state at the beginning if the shop contains followers
		// getUserFollowers gets called from UserCard "changeTabAndGetRequiredData" function
		if (this.props.userCardData.followingPage.totalItems > 0) {
			this.setState({ hasFollowers: true });
		}
	}

	public componentDidUpdate(prevProps: Readonly<IProps>) {
		// Reset data when clicking on a follower
		if (prevProps.userCardData.usercard.id !== this.props.userCardData.usercard.id) {
			this.setState({ hasFollowers: false });
			this.props.resetUserFollowingData();
			this.props.setKeywordFilter('');
			this.props.getUserFollowing(this.props.userCardData.usercard.id, true, '');
		}
		// Change hasFollowers if the shop contains followers
		if (!this.state.hasFollowers && this.props.userCardData.followingPage.totalItems > 0) {
			this.setState({ hasFollowers: true });
		}
	}

	public componentWillUnmount() {
		this.props.setKeywordFilter('');
		this.props.resetUserFollowingData();
	}

	private loadMoreUserFollowing() {
		this.props.getUserFollowing(this.props.userCardData.usercard.id, false, this.props.userCardData.keywordFilter);
	}

	private followUser(_, id: string) {
		this.props.followUser(id, false);
	}

	private unfollowItem(type: string, id: string) {
		this.props.unfollowItem(id, type, false, true);
	}

	private goToCard(id: string, type: string) {
		goToCard(this.props.dispatch, id, type);
	}

	public render() {
		const { t } = this.props;
		const { followingItems, followingPage } = this.props.userCardData;
		const { hasFollowers } = this.state;

		const listProps: IUserFollowingCardList = {
			items: followingItems,
			itemType: c.NODE_TYPE_FOLLOWER_FOLLOWING_ITEM_CARD,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
			followItem: this.followUser,
			unfollowItem: this.unfollowItem,
			goToCard: this.goToCard,
		};

		const emptyResults: JSX.Element = !hasFollowers ? (
			<div className="empty d-flex flex-column justify-content-center align-items-center">
				<img src={require('containers/Html/icons/no-followers-logo.svg')} />
				<p className="p18">{t('User_UserCard_NothingHereYet')}</p>
				<p className="p14">{t('User_Usercard_UserIsNotFollowingAnyone')}</p>
			</div>
		) : (
			<div className="empty d-flex flex-column justify-content-center align-items-center">
				<img src={require('containers/Html/icons/no-followers-logo.svg')} />
				<p className="p18">{t('User_UserCard_NothingHereYet')}</p> {/** change text */}
				<p className="p14">{t('User_Usercard_UserFollowingNotFound')}</p>
			</div>
		);

		return (
			<div className="profileAboutBox">
				{hasFollowers === false ? (
					emptyResults
				) : (
					<div className="followers">
						<SearchUsers parentCard="user" userType="following" />
						{followingPage.totalItems > 0 ? (
							<div className="row folowersSection">
								<ItemCardList {...listProps} />
								{followingPage.totalItems > followingItems.length ? (
									<div className="BottomSection col-12">
										<button className="buttonViewMore" onClick={this.loadMoreUserFollowing}>
											{t('User_UserCard_TabAbout_Button_ViewMore')}
										</button>
									</div>
								) : null}
							</div>
						) : (
							emptyResults
						)}
					</div>
				)}
			</div>
		);
	}
}

export { UserFollowing };
